export default __webpack_public_path__ + "static/media/timer.b5ed1ead.png";